import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';
import "../Styles/Admin/Customerlogin.css";

export default function CustomerLogin() {
  // "login" = Login page, "forgot" = Forgot Password page
  const [view, setView] = useState("login");

  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
  });
  const [customerMessage, setCustomerMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Forgot password state
  const [forgotUsername, setForgotUsername] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");
  const [forgotMessageType, setForgotMessageType] = useState(""); // "success" | "error"
  const [forgotLoading, setForgotLoading] = useState(false);

  const navigate = useNavigate();

  const handleCustomerLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ── Login (calls backend API) ────────────────────────────────────────────
  const handleCustomerLoginSubmit = async (e) => {
    e.preventDefault();

    if (!loginData.username || !loginData.password) {
      setCustomerMessage("Please enter both username and password");
      return;
    }

    // Open a blank tab right away, inside the click, so the browser
    // doesn't block it as a popup. It is pointed at the dashboard
    // after the login succeeds.
    

    try {
      console.log("[CustomerLogin] Sending login request...");

      const res = await fetch(`${API_BASE_URL}/api/customer/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: loginData.username,
          password: loginData.password,
        }),
      });

      console.log("[CustomerLogin] Response status:", res.status);

      const data = await res.json();
      console.log("[CustomerLogin] Response body:", data);

      if (data.success) {
  localStorage.setItem("customerToken", data.token);
  setCustomerMessage("Login successful");

  navigate("/customer/dashboard");
} else {
  setCustomerMessage(data.message || "Invalid username or password");
}
   } catch (err) {
  console.error("[CustomerLogin] Request failed:", err);
  setCustomerMessage("Something went wrong. Please try again.");
}
  };

  // ── Forgot Password (calls backend API) ─────────────────────────────────
  const handleCustomerForgotSubmit = async (e) => {
    e.preventDefault();

    if (!forgotUsername) {
      setForgotMessage("Please enter your username");
      setForgotMessageType("error");
      return;
    }

    setForgotLoading(true);
    setForgotMessage("");

    try {
      const res = await fetch(`${API_BASE_URL}/api/customer/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: forgotUsername }),
      });

      const data = await res.json();

      if (data.success) {
        setForgotMessage(data.message || "Reset link sent!");
        setForgotMessageType("success");
      } else {
        setForgotMessage(data.message || "Something went wrong");
        setForgotMessageType("error");
      }
    } catch (err) {
      setForgotMessage("Something went wrong. Please try again.");
      setForgotMessageType("error");
    } finally {
      setForgotLoading(false);
    }
  };

  const handleBackToLogin = () => {
    setView("login");
    setForgotUsername("");
    setForgotMessage("");
    setForgotMessageType("");
  };

  return (
    <div className="customerlogin-container">
      {/* ---------------- LEFT SIDE ---------------- */}
      <div className="customerlogin-left">
        <div className="customerlogin-logo">
          <img
            src="/New_osw_logo.png"
            alt="Outstanding Workplaces Logo"
            className="customerlogin-logo-img"
          />
        </div>

        <div className="customerlogin-illustration">
          <img src="/Customerlogin_img.png" alt="Outstanding" />
        </div>

        <div className="customerlogin-left-bottom">
          <h2>Welcome Back!</h2>
          <p>Sign in to your Customer account</p>
        </div>
      </div>

      {/* ---------------- RIGHT SIDE ---------------- */}
      <div className="customerlogin-right">
        {view === "login" ? (
          <form className="customerlogin-form" onSubmit={handleCustomerLoginSubmit}>
            <h1 className="customerform-heading">Welcome to Outstanding Workplaces!</h1>

            <p className="customerform-subheading">
              Enter your credentials to access the report dashboard
            </p>

            <label className="customerform-label">User Email ID</label>

            <input
              type="text"
              name="username"
              className="customerform-input"
              placeholder="Enter your Email ID"
              value={loginData.username}
              onChange={handleCustomerLoginChange}
              required
            />

            <label className="customerform-label">Password</label>

            <div className="customerpassword-field">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="customerform-input"
                placeholder="Enter your Password"
                value={loginData.password}
                onChange={handleCustomerLoginChange}
                required
              />
              <img
                src="/Admin_log_eye.png"
                alt="Toggle password visibility"
                className="customerpassword-eye-icon"
                onClick={() => setShowPassword((prev) => !prev)}
              />
            </div>

            <button
              type="button"
              className="customerlink-btn customerforgot-link"
              onClick={() => setView("forgot")}
            >
              Forgot Password?
            </button>

            <button type="submit" className="customerprimary-btn">
              SIGN IN
            </button>

            {customerMessage && (
              <p
                className="customer-login-message"
                style={{ color: customerMessage === "Login successful" ? "green" : "red" }}
              >
                {customerMessage}
              </p>
            )}
          </form>
        ) : (
          <form className="customerlogin-form" onSubmit={handleCustomerForgotSubmit}>
            <h1 className="customerform-heading">Forgot Password?</h1>

            <p className="customerform-subheading">
              Enter your username and we'll send a reset link to the registered
              email.
            </p>

            <label className="customerform-label">User Email ID</label>

            <input
              type="text"
              name="forgotUsername"
              className="customerform-input"
              placeholder="Enter your Email ID"
              value={forgotUsername}
              onChange={(e) => setForgotUsername(e.target.value)}
              required
              autoFocus
            />

            {forgotMessage && (
              <p
                className="customer-forgot-message"
                style={{
                  color: forgotMessageType === "success" ? "#16a34a" : "#dc2626",
                  fontSize: "13px",
                  marginBottom: "12px",
                  textAlign: "center"
                }}
              >
                {forgotMessage}
              </p>
            )}

            <button
              type="button"
              className="customerlink-btn customerback-link"
              onClick={handleBackToLogin}
            >
              <div className="customerback-link-content">
                <img
                  src="/Admin_log-arrow.png"
                  alt="Back"
                  className="customerback-arrow"
                />
                <span>Back to Login</span>
              </div>
            </button>

            <button
              type="submit"
              className="customerprimary-btn"
              disabled={forgotLoading}
              style={{ opacity: forgotLoading ? 0.7 : 1 }}
            >
              {forgotLoading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}